import { request } from './client';

export const apiGetDashboardStats = (days = 30) =>
  request(`/admin/dashboard/stats?days=${encodeURIComponent(days)}`);
